export default __webpack_public_path__ + "static/media/logo.4628133c.png";